import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-scent-notes")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-scent-notes")),
  head: () => ({ meta: [{ title: "هرم العطر للمنتج — Admin" }] }),
});
